import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { Router } from '@angular/router';
import { ToastService } from './toast.service';

@Injectable({
    providedIn: 'root',
})
export class GoBackService {
    alertShown: boolean = false;
    beforeUnloadAlert: boolean = true;
    private goBackSubject = new Subject<string>();
    goBack$ = this.goBackSubject.asObservable();

    constructor(
        private router: Router,
        private locationStrategy: LocationStrategy,
        private toastService: ToastService
    ) {
        // tested this won't stop from going back to different domain.
        this.locationStrategy.onPopState(() => {
            let route = this.router.routerState.snapshot.root;
            while (route) {
                if (route.firstChild) route = route.firstChild;
                else break;
            }

            if (!route.data['backNav'] || route.data['backNav'] === 'noBack' || route.data['backNav'] === 'prevPage') {
                if (!this.alertShown) {
                    this.toastService.add({
                        type: 'error',
                        title: '',
                        message:
                            !route.data['backNav'] || route.data['backNav'] === 'noBack'
                                ? 'This operation is not permitted.'
                                : `Please click '< Go back' from the application page.`,
                    });

                    setTimeout(() => {
                        this.alertShown = false;
                    });
                }

                this.alertShown = true;
                window.history.forward();
            }
        });
    }
}
